import React, { FC, HTMLAttributes } from 'react';
import cx from 'clsx';

import styles from './ModalHeader.module.scss';

import { CloseButton } from 'components/CloseButton';

type ModalHeaderProps = React.AllHTMLAttributes<HTMLDivElement> & {
  onClose?: HTMLAttributes<HTMLButtonElement>['onClick'];
};

export const ModalHeader: FC<ModalHeaderProps> = ({ onClose, className, children, ...props }) => (
  <header className={cx(className, styles.modalHeader)} {...props}>
    <h2 className={styles.heading}>{children}</h2>
    {onClose && <CloseButton className={styles.close} onClick={onClose} />}
  </header>
);

